module.exports = __webpack_public_path__ + "img/gpy4.71ff2aad.png";